<template>
  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentcolor">
    <path d="M12 3L2 21H22L12 3ZM12 9.3L11 10.2L10 9.3L12 5.7L14 9.3L13 9.74471L12 9.3Z" />
  </svg>
</template>

<script>
export default {};
</script>
